export const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  interestedInPersonalTraining: false,
};
